/**
 * Vista Embudo — conversión de los afiliados captados por el promotor:
 * captados → registrados → entraron → jugaron (actividad) → recargaron (conversión).
 * Convertir = PONER PLATA propia (recargar), NO jugar el bono de registro. La
 * métrica estrella es la recarga. Barras con % sobre captados. Read-only.
 * Consume GET /api/cashier/embudo?desde=&hasta=.
 */

import { t } from '../languages.js';
import { rangoPorDefecto } from './_helpers.js';
import { renderChipsFecha } from './chips-fecha.js';

export function renderEmbudo({ apiGet }) {
    const el = document.createElement('div');
    const { desde, hasta } = rangoPorDefecto();

    el.innerHTML = `
        <div class="card-hero" style="margin-bottom:2px;">
            <span class="hero-num" id="pm-embudo-conv">0%</span>
            <div class="hero-label">${t('embudo.conRecarga')} · ${t('embudo.titulo')}</div>
        </div>
        <div class="card">
            <h2>${t('embudo.titulo')}</h2>
            <div class="date-range">
                <input type="date" id="pm-desde" value="${desde}" aria-label="${t('common.desde')}">
                <input type="date" id="pm-hasta" value="${hasta}" aria-label="${t('common.hasta')}">
            </div>
            <div id="pm-embudo-body">
                <div style="text-align:center; color:var(--text-dim); padding:18px;">${t('common.cargando')}</div>
            </div>
        </div>`;

    const body = el.querySelector('#pm-embudo-body');
    const convEl = el.querySelector('#pm-embudo-conv');
    const desdeEl = el.querySelector('#pm-desde');
    const hastaEl = el.querySelector('#pm-hasta');

    const chips = renderChipsFecha({ desdeEl, hastaEl, onChange: () => cargar() });
    desdeEl.closest('.date-range').insertAdjacentElement('beforebegin', chips);

    let cargando = false;
    async function cargar() {
        if (cargando) return;
        cargando = true;
        body.innerHTML = `<div style="text-align:center; color:var(--text-dim); padding:24px;">${t('common.cargando')}</div>`;
        const r = await apiGet(`/api/cashier/embudo?desde=${desdeEl.value}&hasta=${hastaEl.value}`);
        cargando = false;
        if (!r || r.ok === false) {
            body.innerHTML = `<div style="text-align:center; color:var(--danger); padding:24px;">${(r && r.mensaje) || t('common.reintentar')}</div>`;
            return;
        }
        const e = r.embudo || {};
        const total = e.captados || 0;

        // Etapas en orden real: jugar el bono (actividad) ocurre ANTES de poner
        // plata. El paso final = recargaron = la conversión verdadera (verde).
        const etapas = [
            { key: 'captados', n: e.captados || 0, color: '#3b82f6' },
            { key: 'registrados', n: e.registrados || 0, color: '#6366f1' },
            { key: 'conSesion', n: e.con_sesion || 0, color: '#8b5cf6' },
            { key: 'conApuesta', n: e.con_apuesta || 0, color: '#f59e0b' },
            { key: 'conRecarga', n: e.con_recarga || 0, color: '#22c55e' },
        ];

        // Conversión final = RECARGÓ / captados (puso plata = convirtió de verdad,
        // NO jugar el bono). La métrica estrella del embudo.
        const convFinal = total > 0 ? Math.round(((e.con_recarga || 0) / total) * 100) : 0;
        if (convEl) convEl.textContent = convFinal + '%';

        if (total === 0) {
            body.innerHTML = `<div style="text-align:center; color:var(--text-dim); padding:18px; font-size:15px;">${t('common.sinDatos')}</div>`;
            return;
        }

        body.innerHTML = etapas
            .map((et) => {
                const pct = total > 0 ? Math.round((et.n / total) * 100) : 0;
                return `
                <div class="pm-embudo-etapa">
                    <div class="pm-embudo-head">
                        <span class="pm-embudo-nombre">${t('embudo.' + et.key)}</span>
                        <span class="pm-embudo-cifra"><b>${et.n}</b> · ${pct}%</span>
                    </div>
                    <div class="pm-embudo-track">
                        <div class="pm-embudo-fill" style="width:0%; background:linear-gradient(90deg, ${et.color}, ${et.color}cc);" data-pct="${pct}"></div>
                    </div>
                </div>`;
            })
            .join('');
        // Animar el llenado de las barras (motion: crecen tras montar).
        requestAnimationFrame(() => {
            body.querySelectorAll('.pm-embudo-fill').forEach((f) => {
                f.style.width = f.dataset.pct + '%';
            });
        });
    }

    desdeEl.addEventListener('change', cargar);
    hastaEl.addEventListener('change', cargar);
    cargar();

    return el;
}
